export default "__VITE_ASSET__e2667d05__"